import { ToastMessageOptions } from 'primevue/toast'
import { emitter } from './emitter'

const TIMEOUT = 3000

export const showToast = (toast: ToastMessageOptions) => {
  emitter.emit('showToast', toast)
}

export const showToastInfo = (message: string, title = 'Info') => {
  showToast({
    summary: title,
    detail: message,
    severity: 'info',
    life: TIMEOUT
  })
}

export const showToastError = (
  title: string,
  message: string,
  params?: ToastMessageOptions
) => {
  showToast({
    summary: title,
    detail: message,
    severity: 'error',
    life: TIMEOUT,
    ...params
  })
}

export const showToastSuccess = (
  title: string,
  message?: string,
  params?: ToastMessageOptions
) => {
  showToast({
    summary: title,
    detail: message,
    severity: 'success',
    life: TIMEOUT,
    ...params
  })
}
